import React from 'react';
import {useDispatch} from 'react-redux';
import gql from 'graphql-tag';
import {hooks} from 'lib.front';
import {clientLog} from 'src/common/gqlClientes';
import {logIn, loadingModal, openMsg} from 'src/redux-app';

const logInQ = gql`
   query LogIn($user: String!, $pass: String!) {
      logIn(user: $user, pass: $pass) {
         codigo
         nombre
         apPaterno
         apMaterno
         usuario
         email
         condicion
         sucursal
         fechaVigencia
         especialidad
      }
   }
`;
export default function useLogIn() {
   //REDUX
   const dispatch = useDispatch();
   //RECUPERAR ESCRITORIO
   //CALLBACKS LOGIN
   function callbackProcesarData(data) {
      dispatch(logIn(data.logIn));
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
      if (process.env.NOD_ENV === 'development') {
      }
   }

   const [loginCall] = hooks.useApolloLazyQ(
      logInQ,
      {
         callbackProcesarData: callbackProcesarData,
         callbackLoading: callbackLoading,
         callbackError: callbackError
      },
      {
         client: clientLog
      }
   );
   return loginCall;
}
